import { marketingSalesConstants, globalConstants } from "../../constants";

const { SUCCESS } = globalConstants;
const {
  GET_MARKETING_SALES,
  GET_SALES_REPORT,
  GET_TOTAL_EMAIL_AND_SMS_DELIVERED_COUNT,
} = marketingSalesConstants;

//Reducer initial state
const initialState = {
  campaignMetricsData: [],
  campaignMetricsPagination: {
    pageSize: 10,
    totalElements: 0,
    pageNumber: 0,
  },
  totalEmailDelivered: 0,
  totalSmsDelivered: 0,
  salesReport: null,
};

export const marketingSalesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_MARKETING_SALES + SUCCESS:
      return {
        ...state,
        campaignMetricsData: action.data.data,
        campaignMetricsPagination: action.data.page,
      };
    case GET_SALES_REPORT + SUCCESS:
      return {
        ...state,
        salesReport: action.data,
      };
    case GET_TOTAL_EMAIL_AND_SMS_DELIVERED_COUNT + SUCCESS:
      return {
        ...state,
        totalEmailDelivered: action.data.totalEmailsDelivered,
        totalSmsDelivered: action.data.totalSmsDelivered,
      };
    default:
      return state;
  }
};
